import styled from 'styled-components';
import { Select, Tag } from 'antd';
import { HelpTooltip, Icon } from '../../shared/components';
import { useEffect, useState } from 'react';

const Title = styled.div`
  display: flex;
  align-items: center;
`;

const HelpIcon = styled.div`
  margin-left: 4px;
`;

const StyledTag = styled(Tag)`
  max-width: 200px;
  margin: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: middle;
`;

export function HttpTags({ values, setValues }) {
  const [options, setOptions] = useState([]);

  const handleChange = (selectedValues) => {
    const newOptions = selectedValues
      .filter((value) => !options.some((option) => option.value === value))
      .map((value) => ({ value, label: value }));

    if (newOptions.length > 0) {
      setOptions([...options, ...newOptions]);
    }

    setValues(selectedValues);
  };

  useEffect(() => {
    setOptions(values.map((value) => ({ value, label: value })));
  }, [values]);

  return (
    <div>
      <Title>
        <h4>Tags</h4>
        <HelpIcon>
          <HelpTooltip text="Tags for the monitor to help organize and filter." />
        </HelpIcon>
      </Title>
      <Select
        style={{ width: '100%', height: 'auto' }}
        suffixIcon={<Icon name="chevron-down" />}
        mode="multiple"
        placeholder="Please Select"
        value={values}
        onChange={handleChange}
        onSearch={(value) => {
          let newOptions = [];
          for (let i = 0; i < values.length; i++) {
            newOptions.push({ value: values[i], label: values[i] });
          }
          let newValue = { value: value, label: value };
          if (newOptions.includes(newValue) || value === '') {
            return;
          }
          newOptions.push(newValue);
          setOptions(newOptions);
        }}
        options={options}
        dropdownStyle={{ maxHeight: 200, overflowY: 'auto' }}
        tagRender={({ label, closable, onClose }) => (
          <StyledTag
            closable={closable}
            onClose={onClose}>
            {label}
          </StyledTag>
        )}
      />
    </div>
  );
}
